import {
  StyleSheet,
  Text,
  View,
  ScrollView,
  TouchableOpacity,
} from 'react-native';
import React, { FC } from 'react';
import { Formik } from 'formik';
import { IFormData } from '../../../components/FormHelper/FormHelper.types';
import { STYLE_VARS } from '../../../constants/style-vars';
import DropDown from '../../../components/DropDown/DropDown';
import { Button } from '../../../components/Button';
import { DropDownItem } from '../../../models/DropDownItem';
import { TextInput } from '../../../components/TextInput/TextInput';
import DatePicker from '../components/DatePicker';
import { FONTS } from '../../../constants';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';

interface SubmitFormProps {
  initData: {
    country: string;
    clubs?: string[];
    visitPeriod: {
      from: string;
      to: string;
    };
    familyMembers: {
      salutation: string;
      surname: string;
      givenName: string;
      alias: string;
    }[];
  };
  handleSubmit: (data: IFormData) => void;
  clubsData: DropDownItem[];
}

const SubmitForm: FC<SubmitFormProps> = ({
  initData,
  handleSubmit,
  clubsData,
}) => {
  const isDesktop = useIsDesktop();

  return (
    <View>
      <Formik initialValues={initData} onSubmit={handleSubmit}>
        {({ handleSubmit, handleChange, values, setValues }) => (
          <View
            style={{ flexDirection: 'column', rowGap: 20, marginBottom: 100 }}
          >
            <View>
              <View style={{ marginBottom: 10 }}>
                <Text style={styles.headerDropdownText}>Country</Text>
              </View>
              <DropDown
                items={[]}
                dropdownStyle={styles.dropDownStyle}
                placeholder="Select Country"
                setValues={(value) =>
                  handleChange('country')(value.value.toString())
                }
                customDownButton={require('../../../assets/down-arrow.png')}
                customUpButton={require('../../../assets/up-arrow.png')}
              />
            </View>
            <View>
              <View style={{ marginBottom: 10 }}>
                <Text style={styles.headerDropdownText}>
                  Club(s) (Hold to select multiple)
                </Text>
              </View>
              <View
                style={{
                  height: 150,
                  width: '100%',
                  borderWidth: 1,
                  borderColor: STYLE_VARS.fccDarkGrey,
                }}
              >
                <ScrollView style={{ flex: 1 }} nestedScrollEnabled={true}>
                  {clubsData.map((club) => (
                    <TouchableOpacity
                      style={{
                        padding: 10,
                        backgroundColor: values.clubs?.includes(
                          club.value.toString()
                        )
                          ? STYLE_VARS.fccLightGrey
                          : 'white',
                      }}
                      onLongPress={() => {
                        if (!values.clubs?.includes(club.value.toString())) {
                          setValues({
                            ...values,
                            clubs: [...values.clubs!, club.value.toString()],
                          });
                        }
                      }}
                      onPress={() => {
                        if (values.clubs?.includes(club.value.toString())) {
                          const arr = values.clubs.filter(
                            (data) => data !== club.value
                          );
                          setValues({
                            ...values,
                            clubs: arr,
                          });
                        }
                      }}
                      key={club.value}
                    >
                      <Text
                        style={{
                          color: values.clubs?.includes(club.value.toString())
                            ? STYLE_VARS.textColor
                            : STYLE_VARS.fccDarkerGrey,
                          textTransform: 'uppercase',
                          fontFamily: FONTS.AvenirMedium,
                          fontSize: 14,
                          lineHeight: 20,
                          fontWeight: '500',
                        }}
                        numberOfLines={1}
                      >
                        {club.label}
                      </Text>
                    </TouchableOpacity>
                  ))}
                </ScrollView>
              </View>
            </View>
            <View style={{ zIndex: 1 }}>
              <View style={{ marginBottom: 10 }}>
                <Text style={styles.headerDropdownText}>Visiting Period</Text>
              </View>
              <View style={{ flexDirection: 'row', gap: 20 }}>
                <DatePicker
                  placeholder="From"
                  daySelect={initData.visitPeriod.from}
                  showOn={isDesktop() ? 'right' : 'left'}
                />
                <DatePicker
                  placeholder="To"
                  daySelect={initData.visitPeriod.to}
                  showOn={'right'}
                />
              </View>
            </View>
            <View>
              <View style={{ marginBottom: 10 }}>
                <Text style={styles.headerDropdownText}>Family Members</Text>
                <Text
                  style={[
                    styles.headerDropdownText,
                    {
                      color: STYLE_VARS.fccDarkerGrey,
                    },
                  ]}
                >
                  If family members will be travelling to the reciprocal club,
                  Please provide their full names below
                </Text>
                <View>
                  {values.familyMembers.map((member, index) => (
                    <View style={{ marginTop: 30 }} key={index}>
                      <DropDown
                        items={[]}
                        dropdownStyle={styles.dropDownStyle}
                        textStyle={{ color: STYLE_VARS.fccDarkGrey }}
                        placeholder="Salution"
                        setValues={(value) => {}}
                        customDownButton={require('../../../assets/down-arrow.png')}
                        customUpButton={require('../../../assets/up-arrow.png')}
                      />
                      <TextInput
                        placeholder={'SURNAME'}
                        onChangeText={(text) => {
                          let arr = [...values.familyMembers];
                          arr[index].surname = text;
                          setValues({
                            ...values,
                            familyMembers: arr,
                          });
                        }}
                        value={member.surname}
                        placeholderTextColor={STYLE_VARS.fccDarkGrey}
                        style={[styles.input]}
                      />
                      <TextInput
                        placeholder={'GIVEN NAME'}
                        onChangeText={(text) => {
                          let arr = [...values.familyMembers];
                          arr[index].givenName = text;
                          setValues({
                            ...values,
                            familyMembers: arr,
                          });
                        }}
                        value={member.givenName}
                        placeholderTextColor={STYLE_VARS.fccDarkGrey}
                        style={[styles.input]}
                      />
                      <TextInput
                        placeholder={'ALIAS'}
                        onChangeText={(text) => {
                          let arr = [...values.familyMembers];
                          arr[index].alias = text;
                          setValues({
                            ...values,
                            familyMembers: arr,
                          });
                        }}
                        value={member.alias}
                        placeholderTextColor={STYLE_VARS.fccDarkGrey}
                        style={[styles.input]}
                      />
                    </View>
                  ))}
                  <View style={{ alignSelf: 'flex-start', marginTop: 20 }}>
                    <Button
                      text="+ ADD FAMILY MEMBERS"
                      style={STYLE_VARS.blueButton}
                      onPress={() => {
                        setValues({
                          ...values,
                          familyMembers: [
                            ...values.familyMembers,
                            {
                              salutation: '',
                              alias: '',
                              givenName: '',
                              surname: '',
                            },
                          ],
                        });
                      }}
                    />
                  </View>
                </View>
              </View>
            </View>
            <View style={{ marginTop: 20, alignSelf: 'center' }}>
              <Button
                style={STYLE_VARS.blueButton}
                text="SUBMIT"
                onPress={() => {
                  handleSubmit();
                }}
              />
            </View>
          </View>
        )}
      </Formik>
    </View>
  );
};

export default SubmitForm;

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
  },
  dropDownStyle: {
    borderColor: STYLE_VARS.fccDarkGrey,
    paddingHorizontal: 10,
  },
  headerDropdownText: {
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
    fontFamily: FONTS.AvenirMedium,
    fontSize: 13,
    fontWeight: '500',
  },
  input: {
    height: 43,
    paddingHorizontal: 10,
    alignItems: 'flex-start',
    paddingVertical: 10,
    borderWidth: 1,
    borderColor: STYLE_VARS.fccDarkGrey,
    color: STYLE_VARS.fccDarkerGrey,
    fontSize: 12,
    letterSpacing: 0.8,
    fontWeight: '500',
    fontFamily: FONTS.IowanOldStyleBTRoman,
    marginTop: 15,
  },
});
